import { createStore as reduxCreateStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import ReducerStore from '../reducers/ReducerStore';
import { dataRouterMiddleware } from './middleware/dataRouterMiddleware';

const isProduction = process.env.NODE_ENV === 'production';
// Don't need this server-side, so just grab from the window if available
const composeWithDevTools = !isProduction && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

function createStore (storeConfig, storeEnhancements = {}) {
    const {
        customMiddleware = [],
        initState = {},
        dataEngine
    } = storeConfig;

    const { history } = storeEnhancements;
    let reducerStore = storeConfig.reducerStore;

    const thunkEnhancements = {
        componentDataEngine: dataEngine
    };

    if (history) {
        thunkEnhancements.history = history;
    }
    const middlewares = [
        ...customMiddleware,
        thunkMiddleware.withExtraArgument(thunkEnhancements)
    ];

    if (history) {
        const { customUrlBuilder } = storeConfig;
        middlewares.push(dataRouterMiddleware(history, customUrlBuilder));
    }
    let appliedMiddleware;
    const { dataEngineActions = {} } = initState;

    Object.assign(dataEngineActions, dataEngine.engineActions);
    initState.dataEngineActions = dataEngineActions;

    if (!isProduction) {
        middlewares.push(createLogger({duration: true}));
    }

    appliedMiddleware = applyMiddleware(...middlewares);

    if (composeWithDevTools) {
        appliedMiddleware = composeWithDevTools(appliedMiddleware);
    }

    if (!(reducerStore instanceof ReducerStore)) {
        reducerStore = new ReducerStore();
    }

    const store = reduxCreateStore(reducerStore.combine(), initState, appliedMiddleware);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        // module.hot.accept('../reducers', () => {
        //     store.replaceReducer(reducerStore.combineReducers());
        // });
    }
    return { store };
}

export default createStore;
